import { useAsync } from 'react-async-hook';
import useConstant from 'use-constant';
import AwesomeDebouncePromise from 'awesome-debounce-promise';
import { useState } from 'react';

import axios from 'packs/axios';

const productCompare = config => {
  if (config === null) return undefined;

  const { url, method, params } = config;
  const headers =
    method === 'GET'
      ? {
          'Content-Type': 'text/javascript',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        }
      : {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          Accept: 'application/json, text/javascript, */*; q=0.01',
          'X-Requested-With': 'XMLHttpRequest',
        };

  return axios(url, {
    method,
    headers,
    params,
  })
    .then(({ data }) => ({
      success: true,
      data,
      updateProducts: method === 'GET',
    }))
    .catch(({ response }) => {
      if (response) {
        return { success: false, data: response };
      }

      return {
        success: false,
        data: {
          data: { message: 'Network error' },
          status: 500,
          statusText: 'Network error',
        },
      };
    });
};

const useProductCompare = () => {
  const [config, setConfig] = useState(null);

  const debounceProductCompare = useConstant(() =>
    AwesomeDebouncePromise(productCompare, 300),
  );

  const response = useAsync(
    async () => debounceProductCompare(config),
    [config],
  );

  return {
    response,
    setConfig,
  };
};

export default useProductCompare;
